import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { Redirect } from 'react-router-dom'
import moment from 'moment'

import { login, setuser } from '../store/actions'
import { notifOps, server, usePet, useToggle } from '../modules'

import images from '../images'
import Settings from '../components/modals/settings'

const splashUrl = process.env.REACT_APP_SPLASH_URL || `${server}/uploads/data/splash.jpg`

const Login = () => {
    const [username, setUname] = useState('')
    const [password, setPwd] = useState('')

    const { loggedIn, params } = useSelector(state => state.application)
    const dispatch = useDispatch()

    const [settings, toggleSettings] = useToggle(false)

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()

    const onComplete = ({ data }, notif) => {
        closeSnackbar()
        notif('Success', notifOps('success'))
        
        setTimeout(() => {
            dispatch(login(data.token))
            dispatch(setuser(data.user))
        }, 700)
    }   

    document.onkeydown = e => {
        if (e.altKey && e.key === 'S')
            toggleSettings()
    }

    const [{loading}, execute] = usePet('userLogin', {
        username: username, 
        password: password,
        app: 'admin'
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Logging In...' }, bypassLock: true })

    const enableUname = username.trim().length >= 2
    const enablePwd = password.trim().length >= 2

    const performLogin = () => {
        if (!enableUname)
            enqueueSnackbar('Please enter a correct format for username', notifOps('warning'))

        if (!enablePwd)
            enqueueSnackbar('Please enter a correct format for password', notifOps('warning'))

        if (enableUname && enablePwd)
            execute()
    }

    const onKeyUp = e => {
        if (e.keyCode === 13)
            performLogin()
    }

    if (loggedIn)
        return <Redirect to="/app" />

    return (
        <div className="flex flex-col w-full h-full justify-center items-center">
            {/* Row */}
            <div className="w-3/4 md:w-2/3 lg:w-3/5 flex">
                {/* Col */}
                <div className="w-full h-auto bg-gray-400 hidden md:block lg:w-1/2 bg-cover bg-center rounded-l-lg" style={{ backgroundImage: `url(${splashUrl})` }} />
                {/* Col */}
                <div className="w-full lg:w-1/2 bg-white p-5 rounded-lg lg:rounded-l-none">
                    <div className="px-3 mb-4 text-center">
                        <h3 className="pt-4 mb-2 text-2xl">Welcome to { params?.name ?? 'Hisani HMIS' }</h3>
                        <p className="mb-4 text-sm text-gray-700">Please log into your account</p>
                    </div>
                    <div className="px-4 lg:px-8 pt-6 pb-4 mb-1 bg-white rounded">
                        <div className="mb-4">
                            <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="grid-user-name">
                                Username
                            </label>
                            <input
                                onKeyUp={ onKeyUp }
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-user-name"
                                type="text"
                                onChange={ e => setUname(e.target.value) }
                                placeholder="Username" />
                            {/* <input className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline" id="email" type="email" placeholder="Enter Email Address..." /> */}
                        </div>
                        <div className="mb-4">
                            <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="grid-password">
                                Password
                            </label>
                            <input
                                onKeyUp={ onKeyUp }
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-password"
                                type="password"
                                onChange={ e => setPwd(e.target.value) }
                                placeholder="*********" />
                            {/* <input className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline" id="email" type="email" placeholder="Enter Email Address..." /> */}
                        </div>
                        <div className="mb-6 text-center">
                        <button disabled= {loading} onClick={ performLogin } type="submit" className="text-white w-full mt-4 hisani-btn-green-dark font-medium rounded-lg text-sm px-5 py-2.5 text-center">Log In</button>
                            {/* <button className="w-full px-4 py-2 font-bold text-white bg-red-500 rounded-full hover:bg-red-700 focus:outline-none focus:shadow-outline" type="button">
                                Reset Password
                            </button> */}
                        </div>
                        <Settings
                            toggle={ toggleSettings }
                            visible={ settings } />
                        <span className="flex items-center justify-center">
                            Powered by <img onDoubleClick={ () => toggleSettings() } className="ml-2 h-12" src={ images.logo } />
                        </span>
                    </div>
                </div>
            </div>
            <span className='mt-5 flex items-center justify-center text-sm'>
                © { moment().year() } All Rights Reserved, Hisani Systems Ltd.
            </span>
        </div>
    )
}

export default Login